import React from "react";
import "./skeleton.css";

const ResetPasswordSkeleton = () => {
  return (
    <div className="container" style={{ maxWidth: "400px" }}>
      <div className="card shadow-sm border-0 p-4">
        <div className="skeleton mb-4" style={{ width: "100%", height: "40px", borderRadius: "5px" }}></div>

        {/* Captcha Row */}
        <div className="d-flex align-items-center mb-3">
          <div className="skeleton mr-2" style={{ width: "25%", height: "20px" }}></div>
          <div className="skeleton mr-2" style={{ width: "30%", height: "40px", borderRadius: "5px" }}></div>
          <div className="skeleton" style={{ width: "15%", height: "40px", borderRadius: "5px" }}></div>
        </div>

        {/* Send Button */}
        <div className="skeleton" style={{ width: "40%", height: "40px", borderRadius: "20px" }}></div>
      </div>
    </div>
  );
};

export default ResetPasswordSkeleton;
